import { defaultLocaleForRegion } from '../locale.js';
export const clientPlatforms = ['web', 'wechat_mini', 'expo_dev'];
export const miraRegions = ['CN', 'GLOBAL'];
export function defaultRegionForPlatform(platform) {
    return platform === 'wechat_mini' ? 'CN' : 'GLOBAL';
}
export function channelHeaders(input) {
    const region = input.region ?? defaultRegionForPlatform(input.platform);
    const fallbackLocale = defaultLocaleForRegion(region);
    const inputLocale = input.inputLocale ?? fallbackLocale;
    const outputLocale = input.platform === 'wechat_mini' ? 'zh-CN' : input.outputLocale ?? inputLocale;
    return {
        'X-Mira-Client-Platform': input.platform,
        'X-Mira-Region': region,
        'X-Mira-Input-Locale': inputLocale,
        'X-Mira-Output-Locale': outputLocale,
        'Accept-Language': outputLocale,
    };
}
